module.exports = __webpack_public_path__ + "media/styles/images/svg/pip-gray-7a4731f7ca59b0c34eac181520a00e46.svg";